import apiUrl from '../../../constants'
import axios from 'axios'
import {
	Validator
} from 'vee-validate'
import moment from 'moment'
import VueElementLoading from 'vue-element-loading';
import CryptoJS from 'crypto-js';

export default {
	name: 'rto-dto-print-label-new',
	components: {
		VueElementLoading
	},
	data: function () {
		return {
			barcode: '',
			shipmentData: [],
			isLoading: false,
			showTable: false,
			prnData: '',
			userHubId: 0,
			createdby: ''
		}
	},
	created: function () { },
	model: {},
	computed: {},
	filters: {},
	mounted() {
		this.$refs.barcode.focus();
		let userdetailEncrypt = window.localStorage.getItem('userdetail')
		let bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		let plaintext = bytes.toString(CryptoJS.enc.Utf8);
		let userdetail = JSON.parse(plaintext)
		this.userHubId = userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0];
		this.createdby = userdetail[0].email;
	},
	methods: {
		resetData() {
			this.barcode = '';
			this.shipmentData = '';
			this.showTable = false;
			this.isLoading = false;
			this.prnData = '';
			this.$refs.barcode.focus();
			this.$validator.reset();
			this.errors.clear();
		},
		showdetails() {
			this.$validator.validateAll().then((result) => {
				if (result) {
					this.shipmentData = [];
					this.prnData = '';
					this.showTable = false;
					this.isLoading = true;
					axios({
						method: 'GET',
						url: apiUrl.api_url_hubops + 'getShipmentDetailsForRtoDtoSlipNew' + "?FlyerShippingId=" + this.barcode + "&CurrentHubID=" + this.userHubId,
						headers: {
							'authorization': 'authkey xB84JJ89Hd25'
						}
					}).then(result => {
						if (result.data.ResultCode == 100) {
							this.shipmentData = result.data.ResponseData;
							this.shipmentData.rtogctype = (this.shipmentData.rtogctype) ? ' (' + this.shipmentData.rtogctype + ')' : '';
							if (this.shipmentData.shipmenttype && this.shipmentData.shipmenttype.toLowerCase() == 'dto') {
								let awb = [];
								awb[0] = this.shipmentData.shippingid.substring(0, 12);
								awb[1] = this.shipmentData.shippingid.substring(12);
								this.prnData = `^XA
										^SZ2^JMA
										^MCY^PMN
										^PW812
										~JSN
										^JZY
										^LH0,0^LRN
										^XZ
										^XA
										^FO3,73
										^GB803,0,3^FS
										^FO3,134
										^GB803,0,3^FS
										^FO3,240
										^GB803,0,3^FS
										^FO3,328
										^GB803,0,3^FS
										^FO3,423
										^GB803,0,3^FS
										^FO3,516
										^GB803,0,3^FS
										^FO332,75
										^GB0,61,3^FS
										^FO482,77
										^GB0,250,3^FS
										^FO560,77
										^GB0,250,3^FS
										^FO710,76
										^GB0,61,3^FS
										^FO149,241
										^GB0,350,3^FS
										^FO393,425
										^GB0,91,3^FS
										^FO504,426
										^GB0,91,3^FS
										^FO301,520
										^GB0,65,3^FS
										^FT33,43
										^CI0
										^A0N,38,30^FDXPRESSBEES^FS
										^FT115,65
										^A0N,17,23^FDDelivering Happiness^FS
										^FT401,51
										^A0N,39,26^FD${this.shipmentData.dummyRouteCodeData}^FS
										^FT730,48
										^A0N,39,26^FD${this.shipmentData.shipmenttype}^FS
										^FT31,114
										^A0N,42,30^FDRemarks :-^FS
										^FT176,116
										^A0N,42,30^FD${this.shipmentData.remarks}^FS
										^FT341,114
										^A0N,42,30^FD${this.shipmentData.rtogcregion + this.shipmentData.rtogctype}^FS
										^FT510,114
										^A0N,42,30^FD${this.shipmentData.destination}^FS
										^FT587,114
										^A0N,42,30^FD${this.shipmentData.routenumber}^FS
										^FT730,114
										^A0N,42,30^FD${this.shipmentData.routecode}^FS
										^FT489,170
										^A0N,31,16^FDFlier Code^FS
										^FT490,211
										^A0N,23,28^FD${this.shipmentData.truncfliercode}^FS
										^FT571,170
										^A0N,28,19^FDLast WH Handover Date^FS
										^FT570,211
										^A0N,23,28^FD${this.shipmentData.lastwhhandoverdateformated}^FS
										^FO18,148
										^BY2^BCN,50,N,N^FD>:${this.shipmentData.shippingid}^FS
										^FT140,225
										^A0N,25,27^FD${this.shipmentData.shippingid}^FS
										^FT489,295
										^A0N,34,18^FDEway Bill^FS
										^FT589,296
										^A0N,34,28^FD${this.shipmentData.ewaybill}^FS
										^FT22,277
										^A0N,34,23^FDVendor^FS
										^FT22,311
										^A0N,34,23^FDName :-^FS
										^FT157,271
										^A0N,25,20^FD${this.shipmentData.vendorname1}^FS
										^FT157,297
										^A0N,25,20^FD${this.shipmentData.vendorname2}^FS
										^FT157,323
										^A0N,25,20^FD${this.shipmentData.vendorname3}^FS
										^FT23,370
										^A0N,34,23^FDVendor^FS
										^FT23,405
										^A0N,34,23^FDAddress :-^FS
										^FT158,355
										^A0N,17,25^FD${this.shipmentData.vendoraddress1}^FS
										^FT158,375
										^A0N,17,25^FD${this.shipmentData.vendoraddress2}^FS
										^FT158,395
										^A0N,17,25^FD${this.shipmentData.vendoraddress3}^FS
										^FT158,415
										^A0N,17,25^FD${this.shipmentData.vendoraddress4}^FS
										^FT23,465
										^A0N,34,23^FDDestination^FS
										^FT23,500
										^A0N,34,23^FDHub :-^FS
										^FT160,455
										^A0N,28,25^FD${this.shipmentData.destinationhub1}^FS
										^FT160,480
										^A0N,28,25^FD${this.shipmentData.destinationhub2}^FS
										^FT160,505
										^A0N,28,25^FD${this.shipmentData.destinationhub3}^FS
										^FT408,465
										^A0N,34,22^FDClient^FS
										^FT408,498
										^A0N,34,22^FDName :-^FS
										^FT513,450
										^A0N,25,25^FD${this.shipmentData.clientname1}^FS
										^FT513,476
										^A0N,25,25^FD${this.shipmentData.clientname2}^FS
										^FT513,500
										^A0N,25,25^FD${this.shipmentData.clientname3}^FS
										^FT15,545
										^A0N,25,25^FDDelivery^FS
										^FT15,570
										^A0N,25,25^FDPincode :-^FS
										^FT170,554
										^A0N,28,38^FD${this.shipmentData.deliverypincode}^FS
										^FT320,548
										^A0N,23,16^FDPO ID /^FS
										^FT320,570
										^A0N,23,16^FDOrderId :-^FS
										^FO400,530
										^BCN,27,N,N^FD>:${this.shipmentData.poid}^FS
										^FT472,580
										^A0N,23,23^FD${this.shipmentData.poid}^FS
										^PQ1,0,1,Y
										^XZ`;
							} else {
								let rtopdd = (this.shipmentData.rtopdd == undefined || this.shipmentData.rtopdd == null || this.shipmentData.rtopdd == '') ? '' : this.shipmentData.rtopdd.toString().substring(0, 10);
								this.prnData = `^XA
										^SZ2^JMA
										^MCY^PMN
										^PW812
										~JSN
										~SD25^MD0
										^JZY
										^LH0,0^LRN
										^XZ
										^XA
										^FO3,73
										^GB803,0,3^FS
										^FO2,142
										^GB805,0,3^FS
										^FO3,248
										^GB803,0,3^FS
										^FO3,336
										^GB803,0,3^FS
										^FO8,432
										^GB803,0,3^FS
										^FO8,524
										^GB803,0,3^FS
										^FO309,75
										^GB0,66,3^FS
										^FO466,75
										^GB0,66,3^FS
										^FO560,75
										^GB0,66,3^FS
										^FO710,75
										^GB0,66,3^FS
										^FO560,146
										^GB0,101,3^FS
										^FO149,249
										^GB0,91,3^FS
										^FO149,340
										^GB0,91,3^FS
										^FO148,434
										^GB0,91,3^FS
										^FO393,435
										^GB0,91,3^FS
										^FO504,434
										^GB0,91,3^FS
										^FO215,524
										^GB0,60,3^FS
										^FO361,524
										^GB0,60,3^FS
										^FO504,524
										^GB0,60,3^FS
										^FT33,43
										^CI0
										^A0N,38,30^FDXPRESSBEES^FS
										^FT115,65
										^A0N,17,23^FDDelivering Happiness^FS
										^FT382,63
										^A0N,45,30^FD${this.shipmentData.dummyRouteCodeData}^FS
										^FT712,54
										^A0N,45,30^FD${this.shipmentData.shipmenttype}^FS
										^FT21,118
										^A0N,42,30^FDDelivery Type : ${this.shipmentData.deliverytype}^FS
										^FT318,118
										^A0N,42,30^FD${this.shipmentData.rtogcregion + this.shipmentData.rtogctype}^FS
										^FT487,118
										^A0N,42,30^FD${this.shipmentData.destination}^FS
										^FT592,118
										^A0N,42,30^FD${this.shipmentData.routenumber}^FS
										^FT730,118
										^A0N,42,30^FD${this.shipmentData.routecode}^FS
										^FO50,149
										^BY2^BCN,53,N,N^FD>:${this.shipmentData.shippingid}^FS
										^FT50,229
										^A0N,25,27^FD${this.shipmentData.shippingid}^FS
										^FT571,178
										^A0N,28,20^FDLast WH Handover Date^FS
										^FT571,224
										^A0N,30,30^FD${rtopdd}^FS
										^FT20,285
										^A0N,34,23^FDVendor^FS
										^FT20,320
										^A0N,34,23^FDName :-^FS
										^FT160,280
										^A0N,20,20^FD${this.shipmentData.vendorname1}^FS
										^FT160,317
										^A0N,20,20^FD${this.shipmentData.vendorname2}^FS
										^FT20,378
										^A0N,34,23^FDVendor^FS
										^FT20,413
										^A0N,34,23^FDAddress :-^FS
										^FT158,356
										^A0N,17,25^FD${this.shipmentData.vendoraddress1}^FS
										^FT158,377
										^A0N,17,25^FD${this.shipmentData.vendoraddress2}^FS
										^FT158,398
										^A0N,17,25^FD${this.shipmentData.vendoraddress3}^FS
										^FT158,419
										^A0N,17,25^FD${this.shipmentData.vendoraddress4}^FS
										^FT20,473
										^A0N,34,23^FDDestination^FS
										^FT20,508
										^A0N,34,23^FDHub :-^FS
										^FT158,461
										^A0N,28,25^FD${this.shipmentData.destinationhub1}^FS
										^FT158,487
										^A0N,28,25^FD${this.shipmentData.destinationhub2}^FS
										^FT158,514
										^A0N,28,25^FD${this.shipmentData.destinationhub3}^FS
										^FT410,473
										^A0N,34,23^FDClient^FS
										^FT410,503
										^A0N,34,23^FDName :-^FS
										^FT517,461
										^A0N,25,25^FD${this.shipmentData.clientname1}^FS
										^FT517,491
										^A0N,25,25^FD${this.shipmentData.clientname2}^FS
										^FT517,521
										^A0N,25,25^FD${this.shipmentData.clientname3}^FS
										^FT20,566
										^A0N,34,23^FDDelivery Pincode :-^FS
										^FT228,564
										^A0N,28,38^FD${this.shipmentData.deliverypincode}^FS
										^FT380,564
										^A0N,28,19^FDE-WAY Bill :-^FS
										^FT549,562
										^A0N,28,38^FD${this.shipmentData.ewaybill}^FS
										^PQ1,0,1,Y
										^XZ`;
							}

							this.showTable = true;
							if (this.prnData) { this.printerSticker(); }
						} else if (result.data.ResultCode != 100) {
							this.showTable = false;
							this.$alertify.error(result.data.ReturnMessage)
						}
						this.isLoading = false;
					}, error => {
						this.isLoading = false;
						console.error(error)
					})
				}
			});
		},
		printerSticker() {
			let flierRegex = new RegExp("^RVP");
			this.loginput = {
				CurrentHubID: this.userHubId,
				FlyerCode: flierRegex.test(this.barcode.toUpperCase()) ? this.barcode : this.shipmentData.fliercode ? this.shipmentData.fliercode : '',
				FlyerShippingId: this.shipmentData.shippingid ? this.shipmentData.shippingid : this.barcode,
				PrintedBy: this.createdby,
				PrintedDate: moment().format('YYYY-MM-DD HH:mm:ss'),
				Status: 'printFailed'
			}
			this.input = {
				prnData: this.prnData,
				bagNumber: moment().format('DD-MM-YYYY')
			}
			axios({
				method: "POST",
				url: "http://localhost:4500/printer/printbagsticker",
				data: this.input,
			}).then(result => {
				if (result.data.ResultCode == 100) {
					this.loginput.Status = 'printDone';
					this.$alertify.success('Print Generated Successfully');
					this.addStickerLog(this.loginput);
				} else {
					this.$alertify.error(result.data.ReturnMessage);
					this.addStickerLog(this.loginput);
				}
				this.isLoading = false;
			}, error => {
				let code = error.response == undefined ? code = 0 : error.response.status;
				if (code == 500) {
					this.$alertify.error("Printer API error");
				} else if (error) {
					this.$alertify.error("Printer not connected")
				}
				this.isLoading = false;
				this.addStickerLog(this.loginput);
			})
		},
		addStickerLog(input) {
			axios({
				method: "POST",
				url: apiUrl.api_url_hubops + 'addRtoDtoStickerLogs',
				data: input,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25'
				}
			}).then(result => {
				if (result.data.ResultCode == 100) {
					this.$alertify.success('Log Created Successfully');
					this.barcode = "";
					this.$refs.barcode.focus()
					this.$validator.reset();
					this.errors.clear();
				} else {
					this.$alertify.error(result.data.ReturnMessage);
				}
			}, error => {
				this.$alertify.error(error.message);
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/views/components/RTODTOLabelNew/RTODTOLabelNew.js